import { IOfferHandler } from '../../types';
import { Offer } from '../../../../services/exports/Interfaces';
import { CompleteBasketItem } from '../../../../providers/BasketProvider';
import { useTranslation } from 'react-i18next';

const useFreeItemByMinSpendValue: IOfferHandler = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Features:Offers:OfferBadge' });

  const isUnlocked = (offer: Offer, items: CompleteBasketItem[]) =>
    items.reduce((acc, item) => acc + item.actual_price, -getProfit(offer, items)) >= offer.details.min_spend_value;
  const isEligible = (offer: Offer, items: CompleteBasketItem[]) =>
    items.some((item) => offer.details.free_products?.includes(item.entry.id));
  const getMostProfitableFreeItem = (offer: Offer, items: CompleteBasketItem[]) =>
    items
      .filter((item) => offer.details.free_products?.includes(item.entry.id))
      .reduce((acc, current) => (acc && acc.entry?.actual_price > current.entry?.actual_price ? acc : current), null);
  const getProfit = (offer: Offer, items: CompleteBasketItem[]) =>
    getMostProfitableFreeItem(offer, items)?.entry?.actual_price ?? 0;
  const apply =
    (offer: Offer, items: CompleteBasketItem[]) =>
    (item: CompleteBasketItem): CompleteBasketItem => {
      const mostProfitableFreeItem = getMostProfitableFreeItem(offer, items);

      if (item.original_index !== mostProfitableFreeItem?.original_index) {
        return item;
      }

      const actualPrice = item.actual_price - item.entry.actual_price;

      return {
        ...item,
        badges: [...item.badges, t(offer.kind)],
        actual_price: actualPrice,
      };
    };

  return (offer, items) => ({
    apply: apply(offer, items),
    isEligible: isEligible(offer, items),
    isUnlocked: isUnlocked(offer, items),
    profit: getProfit(offer, items),
  });
};

export default useFreeItemByMinSpendValue;
